/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

import { communicationV1MeetingMinutesUpdateUpdate } from '../../__generated__/oazapfts-client';
import { GetAllCommunications } from '../queries/get-all-communications';
import { GetOneMeetingCommunication } from '../queries/get-one-meeting-communication';
import { GetOneMeetingMinutesCommunication } from '../queries/get-one-meeting-minutes-communication';

export namespace UpdateMeetingMinutes {
  export type Input = {
    id: string;
    meetingId?: string;
    title?: string;
    content: string;
  };

  export type Output = void;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const auth = useAuth();
    const me = useMe();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const accessToken = await auth.getAccessToken();
        const result = await communicationV1MeetingMinutesUpdateUpdate(
          {
            uuid: input.id,
            updateMeetingMinutesViewMeetingMinutesInputRequest: {
              subject: input.title,
              email_id: input.meetingId,
              content: input.content,
            },
            xUserName: me.displayName,
            xUserEmail: me.email,
          },
          {
            baseUrl: `${appConfig.bffUrl}/plex`,
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (result.status !== 200) {
          throw new Error('Fail to update meeting minutes');
        }
      },
      async onSuccess(_, input) {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: GetAllCommunications.key({}),
          }),
          queryClient.invalidateQueries({
            queryKey: GetOneMeetingMinutesCommunication.key({ id: input.id }),
          }),
          input.meetingId
            ? queryClient.invalidateQueries({
                queryKey: GetOneMeetingCommunication.key({
                  id: input.meetingId,
                }),
              })
            : undefined,
        ]);
      },
    });
  }
}
